var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoeDisplay-Bold wow animate__fadeInUp banner-title"},[_vm._v(" A research-driven digital asset investment firm ")])}
var staticRenderFns = []

export { render, staticRenderFns }